import { render, staticRenderFns } from "./purchaseBatchDetailInfoAdd.vue?vue&type=template&id=22732d1b&scoped=true&"
import script from "./purchaseBatchDetailInfoAdd.vue?vue&type=script&lang=js&"
export * from "./purchaseBatchDetailInfoAdd.vue?vue&type=script&lang=js&"
import style0 from "./purchaseBatchDetailInfoAdd.vue?vue&type=style&index=0&id=22732d1b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22732d1b",
  null
  
)

export default component.exports